import React from 'react';

/**
 * GlassPanel - Reusable glassmorphism container component
 * Provides consistent frosted glass styling across the application
 * 
 * Usage:
 *   <GlassPanel>Your content</GlassPanel>
 *   <GlassPanel className="p-8">Custom padding</GlassPanel>
 */
export function GlassPanel({ children, className = '', ...props }) {
  const baseClasses = `
    rounded-2xl
    border border-white/20
    bg-white/5
    backdrop-blur-xl
    shadow-[0_8px_30px_rgba(0,0,0,0.12)]
    ring-1 ring-white/10
    supports-[backdrop-filter]:bg-white/5
    hover:bg-white/8
    transition-colors
    duration-200
  `.trim().replace(/\s+/g, ' ');

  const mergedClasses = className 
    ? `${baseClasses} ${className}` 
    : baseClasses;

  return (
    <div className={mergedClasses} {...props}>
      {children}
    </div>
  );
}

export default GlassPanel;

